<script setup>
/* Props */
const props = defineProps({
  formattedPrice: {
    type: String,
    default: '',
  },
  showPriceLoader: {
    type: Boolean,
    default: false,
  },
  showPriceData: {
    type: Boolean,
    default: false,
  },
  displayedSalePrice: {
    type: String,
    default: '',
  },
  displayedSavings: {
    type: String,
    default: '',
  },
});

const priceDataTestId = {
  host: 'g__main-price',
  originalPrice: {
    wrapper: 'g__main-price__original-price',
    fromText: 'g__main-price__original-price__from-text',
    value: 'g__main-price__original-price__value',
    savingsText: 'g__main-price__original-price__saving-text',
  },
  discountedPrice: {
    wrapper: 'g__main-price__discounted-price',
  },
  detailsText: 'g__main-price__details-text',
  andUpText: 'g__main-price__and-up-text',
};
</script>

<template>
  <div
    v-if="props.showPriceLoader"
    class="product__info__price__loader-wrapper"
    data-testid="product-info-price-loader"
  >
    <g-loader type="dark" />
  </div>
  <div v-else>
    <g-price
      v-if="props.showPriceData"
      class="product__info__price"
      variant="stacked"
      :dataTestId.prop="priceDataTestId"
      :original-price="props.formattedPrice"
      :discounted-price="props.displayedSalePrice"
      :savings-text="props.displayedSavings"
    />
  </div>
</template>

<style lang="scss" scoped>
.product__info__price {
  font-size: 2rem;
  margin: 0.5rem 0 2rem;
  color: $color-black;
  line-height: 2.5rem;

  &__loader-wrapper {
    width: 4.6875rem; // 75px
    margin: 1rem 0 2.5rem;
  }

  :deep(.g__price--strike) {

    .savings-text {

      .price-save-text {
        margin-right: 0.25rem;
      }
    }
  }
}
</style>
